module.exports = __webpack_public_path__ + "static/img/dsh.41442b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dsh.png
// module id = 4ANf
// module chunks = 167